<script setup>
import art from "~/assets/art";

const paintings = art.filter((piece) => piece.type === "painting");
const sculptures = art.filter((piece) => piece.type === "sculpture");

const groups = [
  {
    title: "Sculptures",
    pieces: sculptures,
  },
  {
    title: "Paintings",
    pieces: paintings,
  },
];
</script>

<template>
  <div>
    <div class="space-y-12">
      <div v-for="group in groups" :key="group.title">
        <h2 class="w-48 border-b-5 border-green-700 text-2xl">{{ group.title }}</h2>
        <div class="grid place-items-center gap-8 pt-12 lg:grid-cols-2 lg:gap-16 xl:grid-cols-3">
          <NuxtLink
            v-for="piece in group.pieces"
            :key="piece.slug"
            :to="`/art/${piece.slug}`"
            class="cursor-pointer p-8"
            :class="piece.frameColor"
          >
            <NuxtImg :src="'/art/' + piece.thumb" :alt="piece.alt" width="320" height="320" format="webp" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>
